export default function isInOneRole(userRoles, roleArray) {
  if (!userRoles || !userRoles.length || !roleArray || !roleArray.length) {
    return false;
  }

  let userRoleDict = {};
  userRoles.forEach((role, index) => {
    userRoleDict[role.xpas_role_id] = true;
  });

  return (
    roleArray.filter((role) => {
      return userRoleDict[role];
    }).length > 0
  );
}
